import { type FC, type ReactElement } from 'react'
import { FormattedMessage } from 'react-intl'

import { OFFER_PROMOTION_TYPE } from '../../../../offer'

import { ProductSearchResultItemGenericLabel } from './ProductSearchResultItemGenericLabel'
import { type ProductSearchResultItemLabel } from './useProductSearchResultItemLabels'

const getPromotionLabelByPromotionType = (
  promotionType: OFFER_PROMOTION_TYPE,
): ReactElement | null => {
  switch (promotionType) {
    case OFFER_PROMOTION_TYPE.BUNDLE: {
      return (
        <ProductSearchResultItemGenericLabel className="border-light-primary-strong bg-light-brand-medium">
          <FormattedMessage id="general.label.product.bundle" />
        </ProductSearchResultItemGenericLabel>
      )
    }
    case OFFER_PROMOTION_TYPE.FREEBIE: {
      return (
        <ProductSearchResultItemGenericLabel className="border-dark-primary-min bg-light-primary-low text-dark-primary-max">
          <FormattedMessage id="general.label.product.freebie" />
        </ProductSearchResultItemGenericLabel>
      )
    }
    case OFFER_PROMOTION_TYPE.ONE_FOR_ONE:
    case OFFER_PROMOTION_TYPE.ONE_PLUS_ONE: {
      return (
        <ProductSearchResultItemGenericLabel className="border-dark-primary-min bg-light-primary-low text-dark-primary-max">
          <FormattedMessage id="general.label.product.oneforone" />
        </ProductSearchResultItemGenericLabel>
      )
    }
    default: {
      return null
    }
  }
}

export const ProductSearchResultItemPromotionLabelRenderer: FC<{
  label: ProductSearchResultItemLabel
}> = ({ label }) => {
  const promotionType = label.promotionSpecific?.promotionType
  if (!promotionType) {
    return null
  }

  return getPromotionLabelByPromotionType(promotionType)
}
